<form [formGroup]="form">
  <label class="fw-bold margin-bottom-sm" [for]="domID">
    {{ label | translate }}
    <span *ngIf="required" class="filter-select-required" aria-hidden="true">*</span>
  </label>
  <select class="w-100 form-select" [id]="domID" [formControlName]="field" [style.height.rem]="2.625">
    <option *ngFor="let option of options" [ngValue]="option.value">{{ option.label | translate }}</option>
  </select>
</form>
